import { setSpamListFailed, setSpamListPending, setSpamListSucceed } from './actions';
import { ISpamListRequest } from './types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchSpamChats } from '../../services';
import { TChatInListSchema, CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { setRoute } from '../route';

/**
 * Получить список заблокированных чатов
 */
export const getSpamChats =
  ({ timestampSpam }: ISpamListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setSpamListPending({ timestampSpam }));

    const spamChats = await fetchSpamChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestampSpam,
        subAgentRealtyUserId,
      },
    });

    if (!spamChats) {
      dispatch(setSpamListFailed());

      return;
    }

    const spamChatsVisible = chatList.chats.filter((chat: TChatInListSchema) => chat.blocked).concat(spamChats);

    dispatch(setSpamListSucceed(spamChatsVisible.length ? spamChats : []));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(setRoute({ route: ERoute.Spam, cleanRemovedFromSpamChatId: true, cleanRemovedFromArchiveChatId: true }));
  };
